<ion-content>
	<ng-container [ngSwitch]="currentExportStatus">
		<div class="export-wrap">
			<div *ngSwitchCase="exportStatus.Processing">
				<div class="message">{{ 'exportPage.exportWorkfile' | translate }}</div>
				<div class="progress">
					<div class="progress-bar running-progress-bar"></div>
				</div>
			</div>

			<div class="ion-text-center" *ngSwitchCase="exportStatus.Error">
				<div class="export-error-bg"></div>
				<div class="message error">{{ 'exportPage.messages.error' | translate }}</div>
				<ion-button class="ion-no-padding ion-no-margin" (click)="goBack()">{{
					'exportPage.buttons.goBack' | translate
				}}</ion-button>
			</div>
		</div>
	</ng-container>
</ion-content>
